import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Info } from "lucide-react";

interface DataEmptyProps {
  titleTopic: string;
  contentTopic: string;
}

export function DataEmpty({ titleTopic, contentTopic }: DataEmptyProps) {
  return (
    <Card className="w-full border-l-8">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Info className="h-6 w-6" />
          You do not have any {titleTopic} yet
        </CardTitle>
      </CardHeader>
      <CardContent className="ml-8">
        Add a {contentTopic} to get started
      </CardContent>
    </Card>
  );
}
